define((require) => {
    "use strict";

    var _              = require("underscore"),
        Backbone       = require("backbone"),
        ImprovedView   = require("editor/zbone/ImprovedView"),
        template       = require("ui/experience/widgets/youtubeWidget/YouTubeAccountView.tpl"),
        YouTubeService = require("ui/experience/widgets/youtubeWidget/YouTubeService"),
        YouTubeUtil    = require("ui/experience/widgets/youtubeWidget/YouTubeUtil");

    var YouTubeAccountViewModel = Backbone.Model.extend({

        defaults: {
            title: "",
            avatarUrl: "about:blank",
            connecting: true,
            noChannel: false,
            authorized: false,
            videos: []
        },

        hasVideos: function() {
            return this.has("videos") && this.get("videos").length > 0;
        }

    });

    return ImprovedView.extend({

        template: template,

        model: new YouTubeAccountViewModel(), /* Careful, this will make it a singleton */

        events: {
            "click .connect": "_promtAuthorized",
            "click .list-icon": "_promtAuthorized",
            "click .refresh-icon": "_authorize"
        },

        modelEvents: {
            "all": "render"
        },

        regions: {
            accountVideosRegion: ".account-videos-region"
        },

        ui: {
            listIcon: ".list-icon",
            refreshIcon: ".refresh-icon",
            accountVideosRegion: ".account-videos-region"
        },

        initialize: function() {
            _.bindAll(this, "_authorizedHandler");

            // If no data has been feched yet
            if (!this.model.hasVideos()) {
                this._authorize();
            }
        },

        onRender: function() {
            if (this.model.hasVideos()) {
                var collectionView = YouTubeUtil.toCollectionView(this.model.get("videos"));
                this.accountVideosRegion.show(collectionView);
            }
        },

        _authorize: function() {
            // Signal that we're communicating with YouTube
            this.model.set("connecting", true);

            YouTubeService.authorize()
                .then(this._authorizedHandler)
                .fail(() => {
                    this.model.set({
                        authorized: false,
                        connecting: false
                    });
                });
        },

        _promtAuthorized: function() {
            YouTubeService.authorize(false).done(this._authorizedHandler);
        },

        _authorizedHandler: function() {
            var self = this;

            // Signal that we're communicating with YouTube
            this.model.set("connecting", true);

            YouTubeService.getUserData().done((userData) => {
                if (userData !== "NoChannelConnected") {
                    YouTubeService.getVideoMetadata()
                        .done((videoMetadata) => {
                            self.model.set({
                                authorized: true,
                                title: userData.title || "YouTube Account",
                                avatarUrl: userData.thumbnails.medium.url,
                                connecting: false,
                                videos: videoMetadata.items
                            });

                            // No need to show the video container if user has no videos
                            var showOrHide = self.model.hasVideos() ? "show" : "hide";
                            self.ui.accountVideosRegion[showOrHide]();
                        });
                } else {
                    self.model.set({
                        authorized: true,
                        noChannel: true,
                        connecting: false
                    });
                }
            });
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/youtubeWidget/YouTubeAccountView.js